export const getMetaDataOptions = (isCreateMode?: boolean) => {
  const options = [
    "Customer",
    "Account",
    "SupportCase",
    "Lead",
    "Prospect",
    "Contact",
    "Order",
    "Opportunity",
    "Transaction",
    "Products",
    "ReturnAuthorization",
    "Estimate",
    "InventoryItem",
  ].sort();

  return isCreateMode ? ["Select a NetSuite record", ...options] : options;
};

// Mirrors NetSuiteConfigHelper.NormalizeRecordType (velaro-messaging) — converts the
// display record type shown in this picker to NetSuite's REST API record-type slug.
// Keep these two lists in sync; "Order" -> "salesOrder" is the only non-cosmetic mapping,
// everything else is just casing, but the explicit map matches server intent exactly.
const NETSUITE_RECORD_TYPE_MAP: Record<string, string> = {
  Lead: "lead",
  Prospect: "prospect",
  Customer: "customer",
  Account: "account",
  SupportCase: "supportCase",
  Contact: "contact",
  Order: "salesOrder",
  Opportunity: "opportunity",
  ReturnAuthorization: "returnAuthorization",
  Estimate: "estimate",
  InventoryItem: "inventoryItem",
};

export const getNetSuiteRecordTypeName = (recordType: string): string =>
  NETSUITE_RECORD_TYPE_MAP[recordType] ?? recordType.toLowerCase();